


















































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import {
  computed,
  ref,
  defineComponent,
  useStore,
  useContext,
} from '@nuxtjs/composition-api'
import { Context } from '@nuxt/types'
import { Logger } from '../composition/Logger'
import FormGenerator from './FormGenerator.vue'
import { FormType } from '@/contracts/FormType'
import { IBlockList, emptyBlockList } from '@/contracts/BlockList'
import BlockSubscribeForm from '@/components/BlockSubscribeForm.vue'
import BlockList from '@/components/BlockList.vue'
import { FormInputType } from '@/contracts/FormInputType'
import { FormMask } from '@/contracts/FormMask'
import { HTTP_REST_FRONTEND_API } from '@/plugins/axiosFrontendApi'
import { dataStatAgentomExcludesRegions } from '@/apollo/queries/dataStatAgentomExcludeRegions'
import { statAgentomExcludesRegionsAdapter } from '@/apollo/adapters/modules/statAgentomExcludesRegionsAdapter'
import {
  getAgentEmailDescription,
  getStudentDmsEmailDescription,
} from '@/forms-data/custom-form/innerText'
import { BackendModel } from '@/contracts/AppealModel'
import useLogUserAgreement from '@/composition/useLogUserAgreement'

const FORM_DATA = {
  agents: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'Name',
      placeholder: 'Например, Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userNationality',
      type: FormInputType.Text,
      label: 'Гражданство',
      formKey: 'Nationality',
      placeholder: 'Например, РФ',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Почта',
      placeholder: 'example@mail.ru',
      formKey: 'Email',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер для связи',
      formKey: 'Tel',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      type: 'regionWithType',
      label: 'Выберите регион',
      formKey: 'Регион',
      placeholder: 'например, Москва',
      mask: FormMask.NotSet,
      field: 'InputRegion',
      onlyRegions: true,
      excludesRegions: {
        enable: true,
        regions: [],
      },
      rules: ['required', 'region', 'excludesRegions'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  response: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'Name',
      placeholder: 'Например, Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Почта',
      placeholder: 'example@mail.ru',
      formKey: 'Email',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер для связи',
      formKey: 'Tel',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userUrl',
      type: FormInputType.Text,
      label: 'Прикрепите ссылку на портфолио или резюме',
      formKey: 'Url',
      placeholder: 'например, www.cv.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['site'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'userFile',
      type: FormInputType.Text,
      label: 'Или загрузите его файлом',
      formKey: 'File',
      accept: 'application/pdf, image/jpeg, image/png',
      placeholder:
        '<span class="red-text">Выберите файл</span><span> или перенесите его в эту область</span>',
      mask: FormMask.NotSet,
      field: 'InputFile',
      rules: ['file'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  responseIntern: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Например, Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Почта',
      placeholder: 'example@mail.ru',
      formKey: 'Email',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер для связи',
      formKey: 'Телефон',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      type: 'regionWithType',
      label: 'Выберите регион',
      formKey: 'Регион',
      placeholder: 'например, Москва',
      mask: FormMask.NotSet,
      field: 'InputRegion',
      onlyRegions: true,
      excludesRegions: {
        enable: true,
        regions: [],
      },
      rules: ['required', 'region', 'excludesRegions'],
    },
    {
      id: 'speciality',
      type: FormInputType.Text,
      label: 'Укажите специальность и учебное заведение',
      formKey: 'Специальность',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'userUrl',
      type: FormInputType.Text,
      label: 'Прикрепите ссылку на портфолио или резюме',
      formKey: 'Сайт портфолио',
      placeholder: 'например, www.cv.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['site'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'userFile',
      type: FormInputType.Text,
      label: 'Или загрузите его файлом',
      formKey: 'Файл',
      placeholder:
        '<span class="red-text">Выберите файл</span><span> или перенесите его в эту область</span>',
      mask: FormMask.NotSet,
      field: 'InputFile',
      accept: 'application/pdf, image/jpeg, image/png',
      rules: ['file'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  responseStartCareer: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'Name',
      placeholder: 'Например, Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Почта',
      placeholder: 'example@mail.ru',
      formKey: 'Email',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер для связи',
      formKey: 'Tel',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      type: 'regionWithType',
      label: 'Выберите регион',
      formKey: 'Регион',
      placeholder: 'например, Москва',
      mask: FormMask.NotSet,
      field: 'InputRegion',
      onlyRegions: true,
      excludesRegions: {
        enable: true,
        regions: [],
      },
      rules: ['required', 'region', 'excludesRegions'],
    },
    {
      id: 'userUrl',
      type: FormInputType.Text,
      label: 'Прикрепите ссылку на портфолио или резюме',
      formKey: 'Url',
      placeholder: 'например, www.cv.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['site'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'userFile',
      type: FormInputType.Text,
      label: 'Или загрузите его файлом',
      formKey: 'File',
      placeholder:
        '<span class="red-text">Выберите файл</span><span> или перенесите его в эту область</span>',
      mask: FormMask.NotSet,
      field: 'InputFile',
      accept: 'application/pdf, image/jpeg, image/png',
      rules: ['file'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  subscribe: [
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Адрес электронной почты',
      placeholder: 'example@mail.ru',
      formKey: 'Email',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'email'],
    },
  ],
  tender: [
    {
      id: 'userCompany',
      type: FormInputType.Text,
      label: 'Название компании',
      formKey: 'Компания',
      placeholder: 'Введите текст',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'userCity',
      label: 'Выберите регион или город проведения тендера',
      mask: FormMask.NotSet,
      formKey: 'Регион',
      placeholder: 'например, Москва',
      field: 'InputRegion',
      type: 'regionWithType',
      rules: ['required'],
    },
    {
      id: 'userProduct',
      type: FormInputType.Text,
      label: 'Выберите тип страхования',
      formKey: 'Тип страхования',
      placeholder: 'Выберите',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Авто',
          value: 'Авто',
        },
        {
          name: 'Здоровье',
          value: 'Здоровье',
        },
        {
          name: 'Имущество',
          value: 'Имущество',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'E-mail',
      formKey: 'email',
      placeholder: 'mail@email.ru',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  buyByTel: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      type: 'regionWithType',
      label: 'Регион',
      formKey: 'Регион',
      placeholder: 'Введите регион',
      mask: FormMask.NotSet,
      field: 'InputRegion',
      rules: ['required'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
  buyByTelSMS: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'time',
      type: FormInputType.Text,
      label: 'Время звонка',
      formKey: 'Время звонка',
      placeholder: 'Выберите время звонка',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Любое',
          value: 'all',
        },
        {
          name: 'с 9 до 12',
          value: '9-12',
        },
        {
          name: 'с 12 до 15',
          value: '12-15',
        },
        {
          name: 'с 15 до 18',
          value: '15-18',
        },
        {
          name: 'с 18 до 21',
          value: '18-21',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
  callbackRegion: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      label: 'Выберите регион',
      mask: FormMask.NotSet,
      formKey: 'Регион',
      field: 'InputRegion',
      placeholder: 'например, Москва',
      type: 'regionWithType',
      rules: ['required', 'region'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
  callback: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Ваша почта',
      formKey: 'email',
      placeholder: 'hello@email.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userCity',
      label: 'Ваш город',
      formKey: 'Адрес',
      mask: FormMask.NotSet,
      placeholder: 'Введите',
      useFullAddress: true,
      field: 'InputRegion',
      type: 'address',
      rules: ['required'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['required', 'comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
  rgsLife: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Ваша почта',
      formKey: 'email',
      placeholder: 'hello@email.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      label: 'Выберите регион',
      mask: FormMask.NotSet,
      formKey: 'Регион',
      field: 'InputRegion',
      placeholder: 'например, Москва',
      type: 'regionWithType',
      rules: ['required', 'region'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: [],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  ipoteka: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Ваша почта',
      formKey: 'email',
      placeholder: 'hello@email.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      label: 'Выберите регион',
      mask: FormMask.NotSet,
      formKey: 'Регион',
      field: 'InputRegion',
      placeholder: 'например, Москва',
      type: 'regionWithType',
      rules: ['required', 'regionExcludeNewRegions'],
    },
    {
      id: 'userBank',
      type: FormInputType.Select,
      label: 'Наименование банка',
      formKey: 'Наименование банка',
      placeholder: 'Выберите банк',
      mask: FormMask.NotSet,
      field: 'InputSelect',
      selectOptions: [
        { name: 'ВТБ (вкл. ОТКРЫТИЕ)', value: 'ВТБ (вкл. ОТКРЫТИЕ)' },
        {
          name: 'РНКБ',
          value: 'РНКБ',
        },
        { name: 'СБЕРБАНК РОССИИ', value: 'СБЕРБАНК РОССИИ' },
        { name: 'ДОМ.РФ БАНК', value: 'ДОМ.РФ БАНК' },
        { name: 'АБСОЛЮТ БАНК', value: 'АБСОЛЮТ БАНК' },
        { name: 'ТБАНК (бывш. РОСБАНК)', value: 'ТБАНК (бывш. РОСБАНК)' },
        { name: 'КУБАНЬ КРЕДИТ', value: 'КУБАНЬ КРЕДИТ' },
        { name: 'ПРОМСВЯЗЬБАНК', value: 'ПРОМСВЯЗЬБАНК' },
        { name: 'РОССЕЛЬХОЗБАНК', value: 'РОССЕЛЬХОЗБАНК' },
        { name: 'ГАЗПРОМБАНК', value: 'ГАЗПРОМБАНК' },
        { name: 'АЛЬФА-БАНК', value: 'АЛЬФА-БАНК' },
        { name: 'САНКТ-ПЕТЕРБУРГ БАНК', value: 'САНКТ-ПЕТЕРБУРГ БАНК' },
        { name: 'УРАЛСИБ БАНК', value: 'УРАЛСИБ БАНК' },
        {
          name: 'МОСКОВСКИЙ КРЕДИТНЫЙ БАНК',
          value: 'МОСКОВСКИЙ КРЕДИТНЫЙ БАНК',
        },
        { name: 'ТРАНСКАПИТАЛБАНК', value: 'ТРАНСКАПИТАЛБАНК' },
        { name: 'НОРВИК БАНК', value: 'НОРВИК БАНК' },
        { name: 'СОВКОМБАНК', value: 'СОВКОМБАНК' },
        { name: 'ЗЕНИТ БАНК', value: 'ЗЕНИТ БАНК' },
        {
          name: 'Другой банк',
          value: 'Другой банк',
          isOther: true, // Флаг для дополнительного поля
        },
      ],
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      rules: ['required'],
    },
    {
      id: 'userBankOther',
      type: FormInputType.Text,
      label: 'Укажите название банка',
      formKey: 'Название другого банка',
      placeholder: 'Введите название банка',
      mask: FormMask.NotSet,
      field: 'InputText',
      showIf: (model) => model.userBank === 'Другой банк',
      rules: ['required'],
    },
    {
      id: 'userCause',
      type: FormInputType.Text,
      label: 'Причина обращения',
      formKey: 'Причина обращения',
      placeholder: 'Причина обращения',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Заключение нового договора',
          value: 'newContract',
        },
        {
          name: 'Продление договора',
          value: 'renewal',
        },
        {
          name: 'Внесение изменений',
          value: 'edit',
        },
        {
          name: 'Расторжение договора',
          value: 'termination',
        },
        {
          name: 'Переход из другой страховой компании',
          value: 'transfer',
        },
        {
          name: 'Другое',
          value: 'other',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    // {
    //   id: 'userMortgageBalance',
    //   type: FormInputType.Text,
    //   label: 'Текущий остаток задолженности по ипотеке',
    //   formKey: 'Текущий остаток задолженности по ипотеке',
    //   placeholder: 'Текущий остаток задолженности по ипотеке',
    //   mask: FormMask.NotSet,
    //   field: 'InputText',
    //   rules: ['number'],
    // },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: [],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
  vip: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Как к вам обращаться?',
      formKey: 'ФИО',
      placeholder: 'Введите имя',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userCity',
      type: 'regionWithType',
      label: 'Регион',
      formKey: 'Регион',
      placeholder: 'Введите регион',
      mask: FormMask.NotSet,
      field: 'InputRegion',
      rules: ['required'],
    },
    {
      id: 'userQuestion',
      type: FormInputType.Text,
      label: 'Ваш вопрос',
      formKey: 'Вопрос',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['required', 'question'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  feedback: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['required', 'comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  bso: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Ваши ФИО',
      formKey: 'ФИО',
      placeholder: 'Иванов Иван Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userName', 'required'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Электронная почта',
      formKey: 'Почта',
      placeholder: 'example@mail.ru',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона',
      placeholder: '+7 XXX XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['tel', 'required'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Комментарий',
      formKey: 'Вопрос',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  policyChecking: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: `Your name \n\n (Ваше имя):`,
      formKey: 'ФИО',
      placeholder: 'Jack Daniel',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userName', 'required'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'Your e-mail (Ваш e-mail)',
      formKey: 'Почта',
      placeholder: 'JackDaniel@example.com',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email', 'required'],
    },
    {
      id: 'userComment',
      type: FormInputType.Text,
      label: 'Comment (Комментарий)',
      formKey: 'Комментарий',
      placeholder: 'Текст',
      mask: FormMask.NotSet,
      field: 'InputTextArea',
      rules: ['comment'],
      maxlength: 500,
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['acceptEng'],
      title: 'Я соглашаюсь с условиями',
      link: {
        url: '/privacy',
        label: 'обработки персональных данных',
      },
    },
  ],
  studentDms: [
    {
      id: 'userSurname',
      type: FormInputType.Text,
      label: 'Фамилия',
      formKey: 'Фамилия Страхователя',
      placeholder: 'Иванов',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Имя',
      formKey: 'Имя Страхователя',
      placeholder: 'Иван',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userPatronymic',
      type: FormInputType.Text,
      label: 'Отчество',
      formKey: 'Отчество Страхователя',
      placeholder: 'Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userGender',
      type: FormInputType.Text,
      label: 'Пол',
      formKey: 'Пол Страхователя',
      placeholder: 'Выберите',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Мужской',
          value: 'Male',
        },
        {
          name: 'Женский',
          value: 'Female',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userBirthday',
      type: FormInputType.Text,
      label: 'Дата рождения',
      formKey: 'Дата рождения Страхователя',
      placeholder: 'ДД.ММ.ГГГГ',
      mask: FormMask.DateDDMMYYYY,
      field: 'InputDate',
      rules: ['required', 'dateDDmmYYYY'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона Страхователя',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'E-mail',
      formKey: 'E-mail Страхователя',
      placeholder: 'mail@email.ru',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userPayment',
      type: FormInputType.Text,
      label: 'Предпочтительная оплата',
      formKey: 'Предпочтительная оплата Страхователя',
      placeholder: 'Онлайн или квитанция для банка',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Онлайн',
          value: 'Онлайн',
        },
        {
          name: 'Квитанция для банка',
          value: 'Квитанция для банка',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userSurnamePay',
      type: FormInputType.Text,
      label: 'Фамилия',
      formKey: 'Фамилия Застрахованного',
      placeholder: 'Иванов',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userNamePay',
      type: FormInputType.Text,
      label: 'Имя',
      formKey: 'Имя Застрахованного',
      placeholder: 'Иван',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userPatronymicPay',
      type: FormInputType.Text,
      label: 'Отчество',
      formKey: 'Отчество Застрахованного',
      placeholder: 'Иванович',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userGenderPay',
      type: FormInputType.Text,
      label: 'Пол',
      formKey: 'Пол Застрахованного',
      placeholder: 'Выберите',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Мужской',
          value: 'Male',
        },
        {
          name: 'Женский',
          value: 'Female',
        },
      ],
      field: 'InputSelect',
      rules: [],
    },
    {
      id: 'userBirthdayPay',
      type: FormInputType.Text,
      label: 'Дата рождения',
      formKey: 'Дата рождения Застрахованного',
      placeholder: 'ДД.ММ.ГГГГ',
      mask: FormMask.DateDDMMYYYY,
      field: 'InputDate',
      rules: ['dateDDmmYYYY'],
    },
    {
      id: 'userTelPay',
      type: FormInputType.Tel,
      label: 'Номер телефона',
      formKey: 'Номер телефона Застрахованного',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['tel'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      dynamicContent: 'BlockAcceptMessageStudent',
    },
  ],
  studentDmsEng: [
    {
      id: 'userSurname',
      type: FormInputType.Text,
      label: 'Surname',
      formKey: 'Фамилия Страхователя',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'Name',
      formKey: 'Имя Страхователя',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'userName'],
    },
    {
      id: 'userPatronymic',
      type: FormInputType.Text,
      label: 'Patronymic, middle name',
      formKey: 'Отчество Страхователя',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userGender',
      type: FormInputType.Text,
      label: 'Sex',
      formKey: 'Пол Страхователя',
      placeholder: 'Choose',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Male',
          value: 'Male',
        },
        {
          name: 'Female',
          value: 'Female',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userBirthday',
      type: FormInputType.Text,
      label: 'Date of birth',
      formKey: 'Дата рождения Страхователя',
      placeholder: 'DD.ММ.YYYY',
      mask: FormMask.DateDDMMYYYY,
      field: 'InputDate',
      rules: ['required', 'dateDDmmYYYY'],
    },
    {
      id: 'userTel',
      type: FormInputType.Tel,
      label: 'Phone number',
      formKey: 'Номер телефона Страхователя',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'userEmail',
      type: FormInputType.Text,
      label: 'E-mail',
      formKey: 'E-mail Страхователя',
      placeholder: 'mail@email.ru',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['email'],
    },
    {
      id: 'userPayment',
      type: FormInputType.Text,
      label: 'Preferred payment method',
      formKey: 'Предпочтительная оплата Страхователя',
      placeholder: 'Online or bank receipt',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Online',
          value: 'Online',
        },
        {
          name: 'Bank receipt',
          value: 'Bank receipt',
        },
      ],
      field: 'InputSelect',
      rules: ['required'],
    },
    {
      id: 'userSurnamePay',
      type: FormInputType.Text,
      label: 'Surname',
      formKey: 'Фамилия Застрахованного',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userNamePay',
      type: FormInputType.Text,
      label: 'Name',
      formKey: 'Имя Застрахованного',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userPatronymicPay',
      type: FormInputType.Text,
      label: 'Patronymic, middle name',
      formKey: 'Отчество Застрахованного',
      placeholder: '',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['userNameInsurance'],
    },
    {
      id: 'userGenderPay',
      type: FormInputType.Text,
      label: 'Sex',
      formKey: 'Пол Застрахованного',
      placeholder: 'Choose',
      mask: FormMask.NotSet,
      returnOptionValue: true,
      noResultText: 'К сожалению, ничего не найдено',
      selectOptions: [
        {
          name: 'Male',
          value: 'Male',
        },
        {
          name: 'Female',
          value: 'Female',
        },
      ],
      field: 'InputSelect',
      rules: [],
    },
    {
      id: 'userBirthdayPay',
      type: FormInputType.Text,
      label: 'Date of birth',
      formKey: 'Дата рождения Застрахованного',
      placeholder: 'DD.ММ.YYYY',
      mask: FormMask.DateDDMMYYYY,
      field: 'InputDate',
      rules: ['dateDDmmYYYY'],
    },
    {
      id: 'userTelPay',
      type: FormInputType.Tel,
      label: 'Phone number',
      formKey: 'Номер телефона Застрахованного',
      placeholder: '+7 (XXX) XXX XX XX',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['tel'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      dynamicContent: 'BlockAcceptMessageStudentEng',
    },
  ],
  agentDislocation: [
    {
      id: 'userName',
      type: FormInputType.Text,
      label: 'ФИО, как в договоре ',
      formKey: 'ФИО',
      placeholder: 'ФИО',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'email',
      type: FormInputType.Text,
      label: 'Рабочий e-mail в домене rgs.ru ',
      formKey: 'e-mail',
      placeholder: 'Рабочий e-mail',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required', 'email'],
    },
    {
      id: 'lnr',
      type: FormInputType.Text,
      label: 'ЛНР ',
      formKey: 'ЛНР',
      placeholder: 'ЛНР',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'phone',
      type: FormInputType.Tel,
      label:
        'Номер мобильного телефона, используемый для работы (не будет виден в открытом доступе) ',
      formKey: 'Номер телефона',
      placeholder: 'Номер телефона',
      mask: FormMask.Tel,
      field: 'InputText',
      rules: ['required', 'tel'],
    },
    {
      id: 'city',
      type: FormInputType.Text,
      label: 'Город, в котором вы работаете ',
      formKey: 'Город',
      placeholder: 'Ваш город/населенный пункт',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'address',
      type: FormInputType.Text,
      label:
        'Адрес для отображения вашего имени на карте (можно указать только улицу) ',
      formKey: 'Адрес',
      placeholder: 'Адрес для отображения на карте',
      mask: FormMask.NotSet,
      field: 'InputText',
      rules: ['required'],
    },
    {
      id: 'accept',
      formKey: 'Политика конфиденциальности',
      field: 'InputAccept',
      rules: ['accept'],
      title: 'Я соглашаюсь ',
      link: {
        url: '/docs',
        label: 'с условиями обработки персональных данных',
      },
      dynamicContent: 'BlockAcceptMessage',
    },
  ],
}

@Component
class BlockForms extends Vue {
  @Prop() readonly formType: FormType = FormType.Test
  @Prop() readonly isSubscribe: boolean = false
  @Prop() readonly bitrixId: number = 0
  @Prop() readonly recipientsBitrixId: number = 0
  @Prop() readonly isDarkTheme: boolean = false
  @Prop() readonly idRecipients: string = null
  @Prop() readonly idRegionRecipients: string = null
  @Prop() readonly idRecipientsAlter: string = null
  @Prop() readonly isNewStyle: boolean = false
  @Prop() readonly subtitle: string = ''
  @Prop() readonly formDescriptionSecond: string = ''
  @Prop() readonly formDescriptionSecondEng: string = ''
  @Prop() readonly switchLangLink: string = ''
  @Prop() readonly switchLangLinkEng: string = ''
  @Prop() readonly switchLangLinkText: string = ''
  @Prop() readonly switchLangLinkTextEng: string = ''
  @Prop() readonly formTitle: string = ''
  @Prop() readonly formTitleEng: string = ''
  @Prop() readonly formTitleSecond: string = ''
  @Prop() readonly formTitleSecondEng: string = ''
  @Prop() readonly privacyTitle: string = ''
  @Prop() readonly privacyLinkUrl: string = ''
  @Prop() readonly privacyLinkLabel: string = ''
  @Prop() readonly policyAccept: string = ''
  @Prop() readonly sendButtonText: string = ''
  @Prop() readonly sendButtonTextEng: string = ''
  @Prop() readonly subjectEmailText: string = ''
  @Prop() readonly agentPhoneNumber: string = ''
  @Prop() readonly hasCaptcha: boolean = false
  @Prop({ default: 'ru' }) readonly lang: string = ''
  @Prop() readonly contacts: IBlockList = emptyBlockList()
  static options: any
}

export default defineComponent({
  name: 'BlockForms',
  components: { FormGenerator, BlockSubscribeForm, BlockList },
  props: BlockForms.options.props,

  setup(props: any, { emit }) {
    const { getters } = useStore()
    const ctx = useContext()
    const setStatAgentomExcludesRegions = async () => {
      const {
        data: { statAgentomExcludesRegions },
      } = await ctx.app.apolloProvider.defaultClient.query({
        query: dataStatAgentomExcludesRegions,
      })

      const regionInput = FORM_DATA.agents.find(
        (field) => field.id === 'userCity'
      )
      regionInput.excludesRegions.regions = statAgentomExcludesRegionsAdapter(
        statAgentomExcludesRegions
      )
    }

    const logUserAgreement = useLogUserAgreement()

    const { subtitle, isNewStyle } = props
    const subtitleType = !isNewStyle
      ? subtitle
      : subtitle ||
        'Оставьте свои данные, мы перезвоним в течение дня и проконсультируем'
    setStatAgentomExcludesRegions()

    const formRoute = ctx.$config.SM_API_SEND_FORM
    const btnLabel = computed(() => {
      let btnLabel = 'Свяжитесь со мной'
      if (props.formType === 'checkDoc') {
        btnLabel = 'Запросить документы'
      }
      if (
        props.formType === 'bso' ||
        props.formType === 'feedback' ||
        props.formType === 'studentDms' ||
        props.formType === 'studentDmsEng' ||
        props.formType === 'agentDislocation'
      ) {
        btnLabel = 'Отправить'
      }
      if (props.formType === 'response' || props.formType === 'agents') {
        btnLabel = 'Отправить заявку'
      }
      if (props.formType === 'policyChecking') {
        btnLabel = props.lang === 'en' ? 'Verify' : 'Проверить'
      }
      return btnLabel
    })
    // получать из стора для каждой формы
    const isLoading = ref(false)
    const isFormSend = ref(false)
    const isError = ref(false)
    const successMessage = ref('')
    const errorMessage = ref('')
    const pages = computed(() => getters['breadcrumbs/GET_BREADCRUMBS'])
    const [{ text: product = '' } = {}] = (pages.value || []).slice(-1)
    const setTel = (tel: any) => {
      emit('userTel', tel)
    }

    const privacyTitleTest = computed((): string => {
      return `Я соглашаюсь с условиями`
    })

    const privacyLabel = computed((): string => {
      return 'обработки персональных данных'
    })

    const userNameLabel = computed((): string => {
      return props.lang === 'en' ? 'Your Name' : 'Ваши ФИО'
    })

    const apiRoute = computed(() => `/feedback/${props.formType}Form`)
    const forms = computed((): ReadonlyArray<any> => {
      const relevantForm = (FORM_DATA as any)[props.formType]

      // Обработка только для studentDms
      if (
        props.formType === 'studentDms' ||
        props.formType === 'studentDmsEng'
      ) {
        const splitIndex = relevantForm.findIndex(
          (field) => field.id === 'userSurnamePay'
        )

        const firstPart = relevantForm.slice(0, splitIndex)
        const secondPart = relevantForm.slice(splitIndex)

        return [
          ...firstPart,
          {
            id: 'secondPartHeader',
            name: 'secondPartHeader',
            field: 'HeaderBlock', // Специальный тип для блока заголовка и описания
            groupTitle:
              props.lang === 'en'
                ? props.formTitleSecondEng
                : props.formTitleSecond,
            description:
              props.lang === 'en'
                ? props.formDescriptionSecondEng
                : props.formDescriptionSecond, // Описание из props
          },
          ...secondPart,
        ]
      }

      if (props.formType === 'policyChecking') {
        return relevantForm.map((field) => {
          if (field.id === 'userComment') {
            return {
              ...field,
              // label: props.lang === 'en' ? 'Comment' : 'Комментарий',
              placeholder: `Please Indicate* (Пожалуйста, укажите):\n\nVessel's name (Название судна):\n\nIMO number* (ИМО номер):\n\nP&I Policy number (if availalbe)\nНомер P&I Полиса (если доступен):\n`,
            }
          }
          if (field.id === 'accept') {
            return {
              ...field,
              title: `I agree to the terms of <a href="/privacy" class="link--basic policy-link nuxt-link-active" target="_blank">processing analytical data</a> (Я соглашаюсь с условиями <a href="/privacy" class="link--basic policy-link nuxt-link-active" target="_blank">обработки персональных данных</a>)`,
              link: {
                url: '',
                label: '',
              },
            }
          }

          return field
        })
      }

      return relevantForm
    })
    const checkIsItFile = (val) =>
      val &&
      typeof val === 'object' &&
      'name' in val &&
      'size' in val &&
      'type' in val

    const submitBuyByTelSMS = async (formData) => {
      return await ctx.$api.requests.sendSms(
        formData.userName,
        formData.userTel,
        props.agentPhoneNumber,
        formData.time
        // formData.verifyToken
      )
    }

    const defaultRecipientPropId = props.idRecipients
    const rnkbRecipientEmail = props.idRecipientsAlter

    const bitrixId = props.bitrixId
    const recipientsBitrixId = props.recipientsBitrixId

    const submitForm = async (formData: any) => {
      emit('update:loading', true)

      // Обработка buyByTelSMS, препятствует отправке формы при неуспешном запросе
      if (props.formType === 'buyByTelSMS') {
        try {
          const response = await submitBuyByTelSMS(formData)

          if (response.data.status !== 200) {
            emit(
              'failed',
              response.data.status === 429
                ? 'Запрос на отправку смс можно отправить один раз в минуту.'
                : ''
            )

            emit('update:loading', false)
            return
          }
        } catch (e) {
          emit('failed')

          emit('update:loading', false)
          Logger.error(e)
          return
        }
      }

      // Подготовка данных
      const value = {
        ...formData,
        userCityCode: formData.userCity?.regionId || '',
      }
      const files = []
      let description = ''

      // Формирование description в зависимости от типа формы
      if (
        props.formType === 'studentDms' ||
        props.formType === 'studentDmsEng'
      ) {
        description = getStudentDmsEmailDescription(formData)
      } else if (props.formType === 'agentDislocation') {
        description = getAgentEmailDescription(formData)
      } else {
        // Общий description для других форм
        forms.value
          .filter(
            (form) =>
              form.field === 'InputRegion' || form.field === 'InputOfficeMap'
          )
          .forEach((form) => {
            if (form.field === 'InputOfficeMap') {
              value[form.id] = formData[form.id]?.value.branch_code
            }
            if (form.field === 'InputRegion') {
              value[form.id] = formData[form.id]?.[form.type]
            }
          })

        for (const key in value) {
          const { formKey } = forms.value.find((form) => form.id === key) || {}
          if (!checkIsItFile(value[key])) {
            if (value[key]) {
              description += `${
                formKey !== undefined ? formKey : 'Код региона/города'
              }: ${value[key]}<br>`
            } else {
              description += `${formKey}: не указано<br>`
            }
          } else {
            files.push(value[key])
          }
        }
        description += `Cтраница сайта: ${window.location.href}<br>`
        description += `Продукт: ${product}<br>`
      }

      // Формирование FormData
      const { userName, userEmail, userTel = '' } = value
      const formDataData = new FormData()
      const defaultSubject = `Новая заявка с сайта - ${
        userName || userEmail
      } - ${product} - ${userTel}`
      let name = defaultSubject
      if (props.subjectEmailText) {
        name = props.subjectEmailText
        const variables = props.subjectEmailText
          .match(/\$\{[a-zA-Z]+\}/g)
          ?.map((variable) => variable.replace('${', '').replace('}', ''))
        variables?.forEach((variable) => {
          const variableVal =
            (variable === 'product' && product) ||
            (variable === 'defaultSubject' && defaultSubject) ||
            value[variable] ||
            ''
          name = name.replace('${' + variable + '}', variableVal)
        })
      }

      formDataData.append('name', name)

      // Особая обработка description для buyByTelSMS
      if (props.formType === 'buyByTelSMS') {
        formDataData.append(
          'description',
          `РГС QR: ${userName} +${userTel.replace(/\D+/g, '')} ${
            value.time === 'all' ? '' : value.time
          } <br/> Сообщение отправлено со страницы: ${location.href}`
        )
      } else {
        formDataData.append('description', description)
      }

      formDataData.append('iblockCode', `form-${props.formType}`)

      // Добавление файлов
      if (files.length) {
        files.forEach((file, i) => formDataData.append(String(i), file))
      }

      // Дополнительные поля для других типов форм
      const regionValue = forms.value.find((_) => _.field === 'InputRegion')
      if (
        (props.formType === 'ipoteka' ||
          props.formType === 'rgsLife' ||
          props.formType === 'agents') &&
        regionValue
      ) {
        formDataData.append('region', value[regionValue.id])
      }

      if (value.userBank === 'РНКБ') {
        formDataData.append('emailPropId', rnkbRecipientEmail)
        formDataData.append('bankNameValue', value.userBank)
      } else if (regionValue) {
        formDataData.append(
          'emailPropId',
          value[regionValue.id].includes('Московская обл') ||
            value[regionValue.id].includes('г Москва')
            ? props.idRecipients
            : props.idRegionRecipients || props.idRecipients
        )
      } else {
        formDataData.append('emailPropId', defaultRecipientPropId)
      }

      const buildAppealPayload = (model) => {
        const appealPayload: BackendModel = {
          region: {
            title: model.userCity,
            code: String(model.userCityCode),
            client: {
              cityPhoneNumber: model.userTel,
              email: model.userEmail,
              firstName: model.userName?.split(' ')[1] || '',
              lastName: model.userName?.split(' ')[0] || '',
              middleName: model.userName?.split(' ')[2] || '',
            },
          },
          ipoteka: { bankName: model.userBank || '' },
          bank: model.userBank || '',
          emailInfo: {
            elementId: bitrixId,
            propertyId: recipientsBitrixId,
          },
          // outCall будет добавлен ниже условно
        }

        // Добавляем outCall только если комментарий не пустой
        if (value.userComment && value.userComment.trim()) {
          appealPayload.outCall = {
            description: value.userComment.trim(),
          }
        }

        return appealPayload
      }

      const logAppeal = async (model, api) => {
        try {
          const appealLogPayload = buildAppealPayload(model)
          appealLogPayload.pageUrl = window.location.href
          await api.requests.sendAppealLogApplication(appealLogPayload)
        } catch (e) {
          Logger.error('APPEAL LOG ERROR:', e)
        }
      }

      try {
        let sendResult
        if (props.formType === 'ipoteka' && value.userBank !== 'РНКБ') {
          const appealPayload = buildAppealPayload(value)

          if (value.userEmail) {
            appealPayload.email = value.userEmail
          }
          appealPayload.service = {
            code: 'f16a0fcc-30a0-4d9a-b6da-ccfb7e8d41b6',
          }
          appealPayload.wayAddressing = { code: 'site' }
          appealPayload.ipoteka?.mortgageCause = value.userCause || ''
          appealPayload.bank = value.userBank || ''
          appealPayload.emailInfo?.title = name
          appealPayload.emailInfo?.description = description

          const appealResponse = await ctx.$api.requests.sendAppeal(
            appealPayload
          )
          // Иногда возвращается ошибка вида "Клиент X не связан с соглашением 'Обращения по ипотеке'" с кодом 500
          const appealStatusCode = appealResponse?.data?.response?.code || ''
          sendResult =
            appealResponse?.data?.status === 200 && appealStatusCode !== '500'
        } else {
          const sendFormResponse = await HTTP_REST_FRONTEND_API(
            ctx as Context
          ).post(formRoute, formDataData)
          sendResult = sendFormResponse?.data?.success === true
        }

        if (sendResult && props.formType === 'agents') {
          const becomeAgentResponse = await ctx.$api.requests.becomeAgent({
            userTel: value.userTel,
            userName: value.userName,
            userEmail: value.userEmail,
            region: String(value.userCityCode),
          })
          sendResult = becomeAgentResponse?.data?.status === 200
        }

        emit(sendResult ? 'success' : 'failed')

        if (sendResult) {
          logAppeal(value, ctx.$api)

          // Формы не используются, их не логируем
          if (!['feedback', 'tender', 'buyByTelSMS'].includes(props.formType)) {
            let email = value.userEmail
            let phone = value.userTel
            if (props.formType === 'agentDislocation') {
              email = value.email
              phone = value.phone
            }
            const req = { email, phone, agreement: value.accept }
            logUserAgreement(req)
          }
        }
      } catch (e) {
        emit('failed')
        Logger.error(e)
      }

      emit('update:loading', false)
    }
    return {
      btnLabel,
      privacyTitleTest,
      privacyLabel,
      isLoading,
      isFormSend,
      isError,
      successMessage,
      errorMessage,
      apiRoute,
      submitForm,
      submitBuyByTelSMS,
      forms,
      setTel,
      userNameLabel,
      subtitleType,
    }
  },
})
